import * as angular from "angular";

let GroupsViewComponent = {
    selector: "vcGroupsView",
    templateUrl: "/angular/components/group/groups-view.component.html",
    bindings: {
        doubleToolbar: "=?",
    },
    controller: "PeopleController",
};

angular
    .module("group")
    .component(GroupsViewComponent.selector, GroupsViewComponent);
